export const httpErrorPages = {
  unauthorized: {
    path: 'unauthorized',
    title: '401 - UNAUTHORIZED',
    description: 'The request has not been applied because it lacks valid authentication credentials for the target resource.'
  },
  forbidden: {
    path: 'forbidden',
    title: '403 - FORBIDDEN',
    description: 'You don\'t have authorization to view this page.'
  },
  notFound: {
    path: 'not-found',
    title: '404 - NOT FOUND',
    description: 'The page you are looking for might have been removed, had its name changed or is temporarily unavailable.'
  },
  internalServerError: {
    path: 'internal-server-error',
    title: '500 - INTERNAL SERVER ERROR',
    description: 'There is a problem with the resource you are looking for, and it cannot be displayed.'
  },
  otherError: {
    path: 'error',
    title: 'Error',
    description: 'An error occured.'
  }
};
